"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var forms_1 = require("@angular/forms");
var ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
var route_params_service_1 = require("../../../../global-services/route-params.service");
var router_1 = require("@angular/router");
var ngx_clipboard_1 = require("ngx-clipboard");
var sweet_alert_service_1 = require("../../../../global-services/sweet-alert.service");
var router_enum_1 = require("../../../../enums/router.enum");
var ApiFetchingComponent = /** @class */ (function () {
    function ApiFetchingComponent(fb, modalService, routeParamsService, activatedRoute, clipboardApi, sweetAlertService, router) {
        var _this = this;
        this.fb = fb;
        this.modalService = modalService;
        this.routeParamsService = routeParamsService;
        this.activatedRoute = activatedRoute;
        this.clipboardApi = clipboardApi;
        this.sweetAlertService = sweetAlertService;
        this.router = router;
        this.localToken = localStorage.getItem("token");
        this.BASE_URL = "https://" + window.location.hostname + "/";
        this.activatedRoute.data.subscribe(function (data) {
            _this.entityName = data.rsEntity.name;
            _this.daeID = data.rsEntity.id;
            _this.getByKeyUrl = _this.BASE_URL + "api/protected/simpleQuery/getByKey";
            _this.getByBatchUrl = _this.BASE_URL + "api/protected/simpleQuery/getByBatch";
            _this.rsSchemaPkList = data.rsSchemaPkList;
        });
    }
    ApiFetchingComponent.prototype.onNavigateToDataView = function () {
        this.router.navigate(["/" + router_enum_1.EnumMainPageRoute.DataWarehouse + "/" + router_enum_1.EnumDataWarehousePageRoute.DataView, this.daeID]).then();
    };
    ApiFetchingComponent.prototype.copyUrl = function (url) {
        this.sweetAlertService.autoCloseInfo("Copy text", "Success");
        this.clipboardApi.copyFromContent(url);
    };
    ApiFetchingComponent.prototype.copyValue = function (value) {
        this.sweetAlertService.autoCloseInfo("Copy text", "Success");
        this.clipboardApi.copyFromContent(value);
    };
    return ApiFetchingComponent;
}());
exports.ApiFetchingComponent = ApiFetchingComponent;
